// extracted by mini-css-extract-plugin
module.exports = {"img":"styles_img__2P2G_","titleImage":"styles_titleImage__3KDk2","cardHover":"styles_cardHover__OYMhR"};